var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9974 3.16406C8.6374 3.16406 2.66406 9.1374 2.66406 16.4974C2.66406 23.8574 8.6374 29.8307 15.9974 29.8307C23.3574 29.8307 29.3307 23.8574 29.3307 16.4974C29.3307 9.1374 23.3574 3.16406 15.9974 3.16406ZM15.9974 7.16406C18.2107 7.16406 19.9974 8.95073 19.9974 11.1641C19.9974 13.3774 18.2107 15.1641 15.9974 15.1641C13.7841 15.1641 11.9974 13.3774 11.9974 11.1641C11.9974 8.95073 13.7841 7.16406 15.9974 7.16406ZM15.9974 26.0974C12.6641 26.0974 9.7174 24.3907 7.9974 21.8041C8.0374 19.1507 13.3307 17.6974 15.9974 17.6974C18.6507 17.6974 23.9574 19.1507 23.9974 21.8041C22.2774 24.3907 19.3307 26.0974 15.9974 26.0974Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircleFilled);
export default __webpack_public_path__ + "static/media/AccountCircleFilled.d7ef147dcfa6be495911d84fcd12a857.svg";
export { ForwardRef as ReactComponent };